<div class="success">
  <div mat-dialog-titled class="title-row">
    <h2>{{ title | translate }}</h2>
  </div>
  <mat-dialog-content class="mat-typography">
    <div>
      <img width="250" height="250" src="/assets/img/settings/juhu.png" />
      <h2>{{ subtitle | translate }}</h2>
      @if (message && email) {
        <p [innerHTML]="message | translate: { email: email }"></p>
      }
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="center">
    <button mat-stroked-button class="secondary-button" [mat-dialog-close]="false">{{ "settings.users.okBtn" | translate }}</button>
  </mat-dialog-actions>
</div>
